import { useTranslation } from '@/src/i18n';
import { ActivityIndicator, Modal, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { createStyles } from '../TournamentDetailScreen.styles';

interface InviteUserModalProps {
  visible: boolean;
  searchEmail: string;
  setSearchEmail: (email: string) => void;
  message: string;
  setMessage: (message: string) => void;
  searching: boolean;
  onSend: () => void;
  onCancel: () => void;
  colors: {
    overlay: string;
    card: string;
    surface: string;
    border: string;
    text: string;
    textSecondary: string;
    textTertiary: string;
    primary: string;
    primaryText: string;
  };
}

export const InviteUserModal = ({
  visible,
  searchEmail,
  setSearchEmail,
  message,
  setMessage,
  searching,
  onSend,
  onCancel,
  colors,
}: InviteUserModalProps) => {
  const styles = createStyles();
  const { t } = useTranslation();

  return (
    <Modal visible={visible} animationType="slide" transparent={true} onRequestClose={onCancel}>
      <View style={[styles.modalOverlay, { backgroundColor: colors.overlay }]}>
        <View style={[styles.addAdminModal, { backgroundColor: colors.card }]}>
          <Text style={[styles.addAdminModalTitle, { color: colors.text }]}>{t('invitations.inviteByEmail')}</Text>

          <Text style={[styles.addAdminModalLabel, { color: colors.textSecondary }]}>
            {t('invitations.inviteByEmailDesc')}
          </Text>

          <TextInput
            style={[
              styles.addAdminInput,
              { backgroundColor: colors.surface, borderColor: colors.border, color: colors.text },
            ]}
            placeholder="email@example.com"
            placeholderTextColor={colors.textTertiary}
            value={searchEmail}
            onChangeText={setSearchEmail}
            keyboardType="email-address"
            autoCapitalize="none"
            editable={!searching}
          />

          <TextInput
            style={[
              styles.inviteModalMessage,
              { backgroundColor: colors.surface, borderColor: colors.border, color: colors.text },
            ]}
            placeholder={t('invitations.optionalMessage')}
            placeholderTextColor={colors.textTertiary}
            value={message}
            onChangeText={setMessage}
            multiline
            editable={!searching}
          />

          <TouchableOpacity
            style={[styles.addAdminModalBtn, { backgroundColor: searching ? colors.border : colors.primary }]}
            onPress={onSend}
            disabled={searching}
          >
            {searching ? (
              <ActivityIndicator color={colors.primaryText} />
            ) : (
              <Text style={[styles.addAdminModalBtnText, { color: colors.primaryText }]}>{t('invitations.sendInvitation')}</Text>
            )}
          </TouchableOpacity>

          <TouchableOpacity style={styles.addAdminModalCancelBtn} onPress={onCancel}>
            <Text style={[styles.addAdminModalCancelBtnText, { color: colors.primary }]}>{t('common.cancel')}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};
